<div class="sidebar-header">
	<h2>Messages</h2>
	<div class="sidebar-actions">
		<button mat-icon-button class="action-btn" matTooltip="Refresh" (click)="refreshConversations()" [disabled]="isLoading()">
			<mat-icon>refresh</mat-icon>
		</button>
		<button mat-flat-button class="new-btn" (click)="openNewConversationDialog()">
			<mat-icon>edit</mat-icon>
			New
		</button>
	</div>
</div>

@if (isLoading()) {
	<div class="loading-state">
		<mat-spinner diameter="28" />
	</div>
} @else if (conversations().length === 0) {
	<div class="empty-state">
		<div class="empty-icon">
			<mat-icon>chat_bubble_outline</mat-icon>
		</div>
		<p class="empty-title">No conversations yet</p>
		<p class="empty-subtitle">Create one with the <strong>New</strong> button</p>
	</div>
} @else {
	<ul class="conversation-list">
		@for (conv of conversations(); track conv.conversationUuid) {
			<li
				class="conversation-item"
				[class.active]="activeUuid() === conv.conversationUuid"
				matRipple
				[matRippleColor]="'rgba(0,150,136,0.08)'"
				(click)="selectConversation(conv.conversationUuid)"
			>
				<div class="conv-avatar" [class.broadcast]="conv.type === 'BROADCAST'">
					<mat-icon>{{ conv.type | conversationTypeIcon }}</mat-icon>
				</div>
				<div class="conv-info">
					<div class="conv-top-row">
						<span class="conv-type-label">{{ conv.type | conversationTypeLabel }}</span>
						<time class="conv-time">{{ conv.lastMessageAt | formatChatTime }}</time>
					</div>
					<p class="conv-preview">{{ conv.lastMessage }}</p>
				</div>
			</li>
		}
	</ul>
}
